import { render, staticRenderFns } from "./GoodReputation.vue?vue&type=template&id=0d6bae12&scoped=true&"
import script from "./GoodReputation.vue?vue&type=script&lang=js&"
export * from "./GoodReputation.vue?vue&type=script&lang=js&"
import style0 from "./GoodReputation.vue?vue&type=style&index=0&id=0d6bae12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6bae12",
  null
  
)

export default component.exports